import { PATH_CALL_CENTER } from "@/routes/paths";
import { useLocation } from "react-router-dom";
import MainCallCenterTopHeader from "./cc-top-header/main.top.header.cc";
import { useSidebar } from "@/components/ui/sidebar";
import { Menu as MobileMenuIcon } from "lucide-react";

const MainTopHeader: React.FC = () => {
  const location = useLocation();
  const { isMobile, toggleSidebar } = useSidebar();
  const isCallCenterPage = location.pathname.startsWith(PATH_CALL_CENTER);

  if (isCallCenterPage) return <MainCallCenterTopHeader />;

  return (
    <header className="w-full min-h-10 px-5 py-3 flex md:hidden items-center justify-between relative z-[50]">
      {isMobile && (
        <button
          type="button"
          className="cursor-pointer mr-3"
          onClick={toggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <MobileMenuIcon />
        </button>
      )}
      <img className="max-w-[200px] opacity-100 mx-auto" src="/logos/ironpipeline.svg" alt="IronPipeline logo" />
    </header>
  );
};

export default MainTopHeader;
